import { createSlice } from "@reduxjs/toolkit";

export const COURSE_REF_TTL_MS = 15 * 60 * 1000;

const emptySlot = { data: null, fetchedAt: 0 };

const initialState = {
  categories: { ...emptySlot, userId: null },
  instructors: { ...emptySlot, userId: null },
  districts: { ...emptySlot, userId: null },
  courseLabels: { ...emptySlot, roleId: null },
  trainingTopicCounts: { ...emptySlot },
};

export const courseReferenceSlice = createSlice({
  name: "courseReference",
  initialState,
  reducers: {
    setCategories(state, { payload }) {
      state.categories = {
        data: payload.data,
        userId: payload.userId,
        fetchedAt: Date.now(),
      };
    },
    setInstructors(state, { payload }) {
      state.instructors = {
        data: payload.data,
        userId: payload.userId,
        fetchedAt: Date.now(),
      };
    },
    setDistricts(state, { payload }) {
      state.districts = {
        data: payload.data,
        userId: payload.userId,
        fetchedAt: Date.now(),
      };
    },
    setCourseLabels(state, { payload }) {
      state.courseLabels = {
        data: payload.data,
        roleId: payload.roleId,
        fetchedAt: Date.now(),
      };
    },
    setTrainingTopicCounts(state, { payload }) {
      state.trainingTopicCounts = { data: payload, fetchedAt: Date.now() };
    },
    resetCourseReference: () => initialState,
  },
});

export const {
  setCategories,
  setInstructors,
  setDistricts,
  setCourseLabels,
  setTrainingTopicCounts,
  resetCourseReference,
} = courseReferenceSlice.actions;

export default courseReferenceSlice.reducer;
